<h2 class="page-title">Help</h2>

<div style="margin-bottom: 5px">
    <button type="button" pButton icon="pi pi-chevron-down" (click)="toggleExpandAll(true)" style="margin-right:.25em" title="Expand all" 
        tabindex=0 aria-label="Expand all" [attr.aria-expanded]="explandAll ? true : false" aria-controls="help-accordion"
        id="help-exapnd-all"></button>
    <button type="button" pButton icon="pi pi-chevron-up" (click)="toggleExpandAll(false)" title="Collapse all" tabindex=0 
        aria-label="Collapse all" [attr.aria-expanded]="!explandAll ? true : false" aria-controls="help-accordion" id="help-collapse-all"></button>
</div>

<p-accordion [multiple]="true" id="help-accordion" role="tablist" aria-labelledby="help-exapnd-all help-collapse-all" (onOpen)="onTabOpen($event)" (onClose)="onTabClose($event)">
    <p-accordionTab header="Dashboard Page" role="tab" [selected]="explandAll" *ngIf="userNodeType == nodeTypes.HSS">
        <ol role="tabpanel">
            <div>1. Summary of trasactions and documents data.</div>
            <div>2. Pie chart gives information about documents of different status.</div>
            <div>3. All the transaction counts are clickable and will nevigate to resective transaction page.</div>
        </ol>
    </p-accordionTab>
    <p-accordionTab header="Transaction pages details" role="tab" [selected]="explandAll" *ngIf="userNodeType == nodeTypes.HSS">
        <ol role="tabpanel">
            <li><b>1. Buy: New Transactions</b></li>
            <ul><li>No any document is uploaded against this transactions.</li></ul>
            <li><b>2. Buy: Pending Transactions</b></li>
            <ul>
                <li>One or more documents are uploaded against this transactions.</li>
                <li>Total face amount / quantity of Approved certificates is less than transaction face amount / quantity.</li>
                <li>One or more external documents are not Approved.</li>
            </ul>
            <li><b>3. Buy: Approved Transactions</b></li>
            <ul>
                <li>Total face amount / quantity of Approved certificates is equal to transaction face amount / quantity.</li>
                <li>All external documents are Approved.</li>
            </ul>
            <li><b>4. Sell: New Transactions</b></li>
            <ul>
                <li>No any document is selected for sell.</li>
            </ul>
            <li><b>5. Sell: Pending Transactions</b></li>
            <ul>
                <li>One or more certificates are selected for sell against this transactions.</li>
                <li>Total face amount / quantity of approved certificates is less than transaction face amount / quantity.</li>
                <li>One or more certificates are pending for approval.</li>
            </ul>
            <li><b>6. Sell: Approved Transactions</b></li>
            <ul>
                <li>Total face amount / quantity of approved certificates is equal to transaction face amount / quantity.</li>
                <li>All documents are approved.</li>
            </ul>
        </ol>
    </p-accordionTab>
    <p-accordionTab header="How to upload document?" role="tab" [selected]="explandAll" *ngIf="userNodeType == nodeTypes.HSS">
        <div>1. Document can be uploaded from all the three pages of {{appLabels.BUY_TRANSACTIONS}} i.e. Buy: New Transactions, Buy: Pending Transactions and Buy: Approved Transactions.</div>
        <div>2. Click on 'Upload' button at the end of transaction row. It will open popup to choose documents.</div>
        <div>3. Select documents by clicking on 'Choose' button. On document selection, document name will get populated in popup.</div>
        <div>4. Select <b>Document Type</b>. The type of document are as follow:
            <li>Certificate</li>
            <li>Checklist</li>
            <li>Supplementary documents</li>
        </div>
        <div>5. Select <b>Usage</b>. There are 2 usage types as follow:
            <li>External – documents which can be shared with other parties, example - certificates etc.</li>
            <li>Internal - for usage only by Ops users only, example – internal checklists</li> 
        </div>
        <div>6. If Document Type is Certificate and Usage is external, then it is mandatory to enter <b>face amount / quantity/Quantity</b></div>
        <div>7. After entering this information for all selected docuemnts, click on "Upload" button. This will open popup to confirm the details entered about selected documents.</div>
        <div>8. If total face amount / quantity of selected document is more than transaction face amount / quantity, it will not allow to upload documents and "<b>Upload</b>" button will be disabled.</div>
        <div>9. At this time, click on "Edit" button and update necessary information and click on "Upload" button.</div>
        <div>10. Click on 'Upload' button on the confirmation popup. This will upload the documents against respective transaction.</div>
    </p-accordionTab>
    <p-accordionTab header="How to verify uploaded document?" role="tab" [selected]="explandAll" *ngIf="userNodeType == nodeTypes.HSS">
        <div>1. Once any document is uploaded, opsuser can able to view that document in Buy: Pending Transactions page. To view document details, click on the ">" at the end of transaction row.</div>
        <div>2. If document is uploaded by a opsuser, any other opsuser can able to view and verify the uploaded document.</div>
        <div>3. There will be 'Verify' button below "Document Status" column of document details table.</div>
        <div>4. On click of "Verify" button, a popup will be opened with options to 'Download', 'Approve' and 'Reject' document.</div>
        <div>5. For rejections, approver will have to mandatorily put the comments.</div>
    </p-accordionTab>
    <p-accordionTab header="How to sell documents?" role="tab" [selected]="explandAll" *ngIf="userNodeType == nodeTypes.HSS">
        <div>1. Opsuser can get sell option from Sell: New Transactions and Sell: Pending Transactions.</div>
        <div>2. From Sell: New Transactions, on click of '>' icon at the end of the row, you can able to see documents available to sell against transaction.</div>
        <div>3. Then select document to sell and click on 'Sell' button.</div>
        <div>4. Then transaction will move to Sell: Pending Transactions.</div>
        <div>5. If opsuser want to sell more documents against that transaction, then go to Sell: Pending Transactions, click on '>'' arrow for the transaction and click on "<b>Pending Sale</b>"</div>
    </p-accordionTab>
    <p-accordionTab header="How to approve documents selected to sell?" role="tab" [selected]="explandAll" *ngIf="userNodeType == nodeTypes.HSS">
        <div>1. Document verification will be done from Sell: Pending Transactions page.</div>
        <div>2. If document is selected to sell by a opsuser, any other opsuser can able to view and verify the document.</div>
        <div>3. On click of '>'' icon at the end of the row, user can able to see documents selected to sell.</div>
        <div>4. Click on 'Verify' button to verify the document. It will open popup with options to 'Download', 'Approve' and 'Reject' document.</div>
        <div>5. For rejections, approver will have to mandatorily put the comments.</div>
    </p-accordionTab>
    <p-accordionTab header="How do I view a document?" role="tab" [selected]="explandAll">
        <ol class="no-bullet" role="tabpanel">
          <li>1. You can view documents in either the '{{appLabels.BUY_TRANSACTIONS}}' or '{{appLabels.SELL_TRANSACTIONS}}' page.</li>          
          <li>2. Use the arrow icon '>' at the end of a transaction row to display all transactional data and associated documents.</li>
          <li>3. To view a document, click on its name.</li>
        </ol>
    </p-accordionTab>
    <p-accordionTab header="How do I search for transactions?" role="tab" [selected]="explandAll">
        <ol class="no-bullet" role="tabpanel">
          <li>1. Enter a keyword into the search bar and click the magnifying glass icon.</li>
          <li>2. All transactions with a data field containing that keyword will appear.</li>
          <li>3. To reset the search, click the 'x' icon in the search bar.</li>
        </ol>
    </p-accordionTab>
    <p-accordionTab header="How do I filter transactions?" role="tab" [selected]="explandAll">
        <ol class="no-bullet" role="tabpanel">
          <li>1. Use the 'Filter by' drop-down menu to change the way in which your list of transactions is displayed.</li>
          <li>2. Select the data fields you want to use to filter your list.</li>
          <li>3. The data fields you've selected will have a red dot beside them.</li>
          <li>4. Click 'Filter' to view a refined list of transactions, matching your filter options.</li>
          <li>5. The filters you set are displayed at the top left of the table.</li>
          <li>6. To remove a filter click its 'x' icon. To remove all filters at once click 'Reset'.</li>
        </ol>
    </p-accordionTab>
    <p-accordionTab header="How do I search for holdings?" role="tab" [selected]="explandAll">
        <ol class="no-bullet" role="tabpanel">
          <li>1. Enter a keyword into the search bar and click the magnifying glass icon.</li>
          <li>2. All holdings with a data field containing that keyword will appear.</li>
          <li>3. To reset the search, click the 'x' icon in the search bar.</li>
        </ol>
    </p-accordionTab>
    <p-accordionTab header="How do I filter holdings?" role="tab" [selected]="explandAll">
        <ol class="no-bullet" role="tabpanel">
          <li>1. Use the 'Filter by' drop-down menu to change the way in which your list of holdings is displayed.</li>
          <li>2. Select the data fields you want to use to filter your list.</li>
          <li>3. The data fields you've selected will have a red dot beside them.</li>
          <li>4. Click 'Filter' to view a refined list of holdings, matching your filter options.</li>
          <li>5. The filters you set are displayed at the top left of the table.</li>
          <li>6. To remove a filter click its 'x' icon. To remove all filters at once click 'Reset'.</li>
        </ol>
    </p-accordionTab>
</p-accordion>

<div id="app-version">
    UI: {{uiVersion}} &nbsp; 
    Api: {{apiVersion}} &nbsp; 
    CordaApp Contracts States: {{apiCordaVersion ? apiCordaVersion['cordapp-contracts-states'] : ''}} &nbsp; 
    CordaApp Common Shared: {{apiCordaVersion ? apiCordaVersion['cordapp-common-shared'] : ''}} &nbsp; 
    CordaApp Customer: {{apiCordaVersion ? apiCordaVersion['cordapp-customer'] : ''}}
</div>